export const E_DATA: {
    [key: string]: {
        moduleTitle: string;
    };
} = {
    cn: {
        moduleTitle: '视频教程',
    },
    us: {
        moduleTitle: 'Video Tutorials',
    },
    eu: {
        moduleTitle: 'Video Tutorials',
    },
    uk: {
        moduleTitle: 'Video Tutorials',
    },
    ca: {
        moduleTitle: 'Video Tutorials',
    },
    au: {
        moduleTitle: 'Video Tutorials',
    },
    de: {
        moduleTitle: 'Video-Tutorials',
    },
    fr: {
        moduleTitle: 'Tutoriels vidéo',
    },
    it: {
        moduleTitle: 'Video tutorial',
    },
    es: {
        moduleTitle: 'Videotutoriales',
    },
    jp: {
        moduleTitle: 'ビデオチュートリアル',
    },
    kr: {
        moduleTitle: '비디오 튜토리얼',
    },
    sa: {
        moduleTitle: 'مقاطع الفيديو التعليمية',
    },
    tw: {
        moduleTitle: '教學影片',
    },
    br: {
        moduleTitle: 'Tutoriais em vídeo',
    },
    mx: {
        moduleTitle: 'Videotutoriales',
    },
    ph: {
        moduleTitle: 'Video Tutorials',
    },
    nl: {
        moduleTitle: 'Videotutorials',
    },
};
